/**
 * 问卷 C 端 API
 * 契约来源：bmb-global-spec/openspec/changes/saas-org-questionnaire-mlb-phase1/api-contract.md
 */
import request from '@/utils/request'

const BASE = '/bmmatch/questionnaires'

/**
 * 获取问卷详情（2.1）
 * @param {string} formId 问卷对象 ID
 * @param {object} [params] role=user|staff，默认 user
 */
export function getFormDetail(formId, params = {}) {
  return request({
    url: `${BASE}/forms/${formId}`,
    method: 'get',
    params: { role: 'user', ...params }
  })
}

/**
 * 我的提交列表（2.3）
 * @param {string} formId 问卷对象 ID
 */
export function getMySubmissions(formId) {
  return request({
    url: `${BASE}/forms/${formId}/submissions/me`,
    method: 'get'
  })
}

/**
 * 创建或更新提交（2.2）
 * @param {string} formId 问卷对象 ID
 * @param {object} payload { submissionId?, submitStatus: 'DRAFT'|'SUBMITTED', content: object }
 */
export function submitSubmission(formId, payload) {
  return request({
    url: `${BASE}/forms/${formId}/submissions`,
    method: 'post',
    data: payload,
    qs: false,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * 提交详情（2.4）
 * @param {string} formId 问卷对象 ID
 * @param {string} submissionId 提交记录 ID
 */
export function getSubmissionDetail(formId, submissionId) {
  return request({
    url: `${BASE}/forms/${formId}/submissions/${submissionId}`,
    method: 'get',
    params: { role: 'user' }
  })
}
